import React from "react";
import { Card, CardBody } from "shards-react";
import { Bar } from 'react-chartjs-2';
const options = {
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    display: false
  },
  tooltips: {
    enabled: false,
    custom: false
  },
  elements: {
    point: {
      radius: 0
    },
    line: {
      tension: 0.33
    }
  },
  scales: {
    xAxes: [
      {
        gridLines: false,
        ticks: {
          display: false
        }
      }
    ],
    yAxes: [
      {
        gridLines: false,
        scaleLabel: false,
        ticks: {
          display: false,
          isplay: false,
        }
      }
    ]
  }
}

export default class BarChartSmall extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      data: this.props.data,
      increase: this.props.increase,
      total: this.props.total,
      percentage: this.props.percentage,
    }
  }

  render() {
    const { title, percentage, total, increase, data } = this.state;

    return (
      <Card className="mb-4 card-custom px-3">
        <CardBody className="line-charts-box">
          <div className="line-charts-heading">
            <div className="text-center">
              <span className="line-charts-title d-block mb-4">{title}</span>
              <h6 className="line-charts-total">{total}</h6>
            </div>
            <div className="line-charts-percent text-center">
              {increase ? <span className="green-increase"><i className="fa fa-arrow-up" aria-hidden="true"></i> {percentage} %</span> : <span className="red-decrease"><i className="fa fa-arrow-down" aria-hidden="true"></i> {percentage} %</span>}
            </div>
          </div>
          <Bar type="bar" data={data} options={options} />
        </CardBody>
      </Card>

    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashChartsComponent/barChartSmall.js